<template>
  <div class="iconTable_content"
       ref="iconTable_content"
       style="font-size:16px;width:100%;background:#eff1f5">
    <!-- <div class="iconTable"
         :class="{'hiddenIconTable':iconTableStatus}">
      <div class="list"
           :class="{'list2': item.imgid==='lssh' || item.imgid==='lssh1'}"
           v-for="(item,index) in getAllIconTables"
           :key="index"
           @click="iconcheck(index,item.type,item.imgid,item.meta)">
        <svg class="icon"
             aria-hidden="true"
             style="color:#75819a">
          <use ref="iconitem"
               :href="'#'+item.imgid"
               v-bind:class="{'active':pathNow() === item.type}"></use>
        </svg>
        <div class="listname"
             :class="{'on':pathNow() === item.type}">
          <span>{{item.name}}</span>
        </div>
      </div>
    </div> -->
    <router-view></router-view>
  </div>
</template>
<script>

export default {
  name: 'Report',
  data () {
    return {
      choosed: 0,
      activeComponent: 'AreaRainfall',
      icontables: [],
      iconTableStatus: false,
      posY: ''
    }
  },
  computed: {
    getAllIconTables: {
      get () {
        return this.$store.state.allIconTables
      },
      set () {
        this.$store.dispatch('setSubMenu', '报表分析')
      }
    }
  },
  methods: {
    iconcheck: function (index, type, theid, name) {
      this.$store.dispatch('setAllowPerm', { name: name, type: type })
      this.$router.push({ name: type })
      this.choosed = index
      this.activeComponent = type
    },
    pathNow () {
      // console.log(this.$route.name.split('/')[0])
      return this.$route.name
    }
  },
  created () {
    this.$store.dispatch('setSubMenu', '报表分析')
  },
  mounted () {
    document.body.onmousemove = e => {
      this.posY = e.clientY
      if (this.posY > 140) {
        this.iconTableStatus = true
      } else if (this.posY < 70) {
        this.iconTableStatus = false
      }
    }
    let topDiv = document.getElementsByClassName('top')
    this.$refs['iconTable_content'].style.height = (document.documentElement.clientHeight - topDiv[0].offsetHeight) + 'px'
  }
}
</script>
<style scoped>
body {
  background-color: #f0f2f6;
  margin: 0;
  padding: 0 0 10px 0;
}
.iconTable {
  width: 100%;
  height: 80px;
  z-index: 998;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  position: relative;
  animation: slowSHow 0.5s ease;
}
.hiddenIconTable {
  top: -80px;
  animation: slowHidden 0.5s ease;
}
@keyframes slowHidden {
  0% {
    top: 0;
  }
  100% {
    top: -80px;
  }
}
@keyframes slowSHow {
  0% {
    top: -80px;
  }
  100% {
    top: 0;
  }
}
.iconList {
  height: 100%;
  width: 100%;
  float: left;
}
.list {
  width: 120px;
  height: 100%;
  float: left;
  text-align: center;
  padding-top: 13px;
  cursor: pointer;
  margin-left: 10px;
}
.list:hover svg use,
.list:hover .listname {
  color: #3d6ffb;
}
.list2 {
  width: 150px;
}
.icon {
  width: 26px;
  height: 26px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.listname {
  width: 100%;
  margin-top: 5px;
  color: #666666;
  font-size: 15px;
}
.listname span {
  font-size: 16px;
}
.on {
  color: #3d6ffb !important;
}
.active {
  color: #3d71fb;
}
</style>
